var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmedForcesExpiditionary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 250,
    viewBox: "0 0 650 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    width: 27,
    height: 250,
    fill: "#1A42A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    width: 40,
    height: 250,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471,
    width: 40,
    height: 250,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    width: 40,
    height: 250,
    fill: "#4D1700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511,
    width: 40,
    height: 250,
    fill: "#4D1700"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    width: 40,
    height: 250,
    fill: "#EEBE00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    width: 40,
    height: 250,
    fill: "#EEBE00"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 250,
    fill: "#24471A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591,
    width: 59,
    height: 250,
    fill: "#24471A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    width: 27,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339,
    width: 27,
    height: 250,
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    width: 105,
    height: 250,
    fill: "#8DCFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    width: 105,
    height: 250,
    fill: "#8DCFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmedForcesExpiditionary);
export default __webpack_public_path__ + "static/media/Armed Forces Expiditionary.35663cba89ab6f731e691d9d9093b9f9.svg";
export { ForwardRef as ReactComponent };